'use strict';

export default {
    notes: {}
};
